// Firebase Configuration
// TODO: Replace with your actual Firebase project details

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { isPrerendering as checkPrerendering } from '../utils/prerender';

// Your Firebase configuration
// Get these values from your Firebase project settings
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "your-api-key-here",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "your-app-id",
  measurementId: process.env.REACT_APP_MEASUREMENT_ID || "your-measurement-id"
};

const isPrerendering = checkPrerendering();

// Initialize Firebase (browser runtime only, not during prerender)
let app: FirebaseApp | null = null;
let authInstance: ReturnType<typeof getAuth> | null = null;
let analyticsInstance: ReturnType<typeof getAnalytics> | null = null;
let dbInstance: ReturnType<typeof getFirestore> | null = null;
let storageInstance: ReturnType<typeof getStorage> | null = null;
let googleProviderInstance: GoogleAuthProvider | null = null;

if (!isPrerendering) {
  try {
    app = initializeApp(firebaseConfig);
    authInstance = getAuth(app);

    if (typeof window !== 'undefined') {
      try {
        analyticsInstance = getAnalytics(app);
      } catch (error) {
        console.warn('Analytics initialization failed:', error);
      }
    }

    dbInstance = getFirestore(app);
    storageInstance = getStorage(app);

    googleProviderInstance = new GoogleAuthProvider();
    googleProviderInstance.setCustomParameters({
      prompt: 'select_account',
      display: 'popup'
    });
  } catch (error) {
    console.error('Failed to initialize Firebase:', error);
    // In production/browser we still want to surface this;
    // during prerender we avoid initialization entirely.
    throw error;
  }
}

// Export nullable instances - consumers must handle null (especially during prerender)
export const auth = authInstance;
export const analytics = analyticsInstance;
export const db = dbInstance;
export const storage = storageInstance;
export const googleProvider = googleProviderInstance;

// Firebase initialization check
export const isFirebaseInitialized = () => {
  try {
    if (isPrerendering) {
      // During prerender, we intentionally skip Firebase, but treat it as "ready"
      return true;
    }

    // Check if Firebase app is accessible and services are initialized
    const isReady = !!app && !!authInstance && !!dbInstance && !!storageInstance;
    
    if (!isReady) {
      console.warn('Firebase not fully initialized yet');
    }
    
    return isReady;
  } catch (error) {
    console.error('Firebase initialization check failed:', error);
    return false;
  }
};

export default app;
